import React, { Component } from "react";
// import Immutable from 'immutable';
import clsx from "clsx";
import { withRouter } from "react-router-dom";
import getRemainingTime from "helpers/getRemainingTime";
import RegistrationTwoStepsForm from "components/Forms/RegistrationTwoStepsForm";
// import Immutable from 'immutable';
import { withStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
// import { connect } from 'react-redux';
import config from "config/api";
import Grid from "@material-ui/core/Grid";
// import withWidth from '@material-ui/core/withWidth';
// import isArray from 'mout/lang/isArray';
import IconPlay from "@material-ui/icons/PlayCircleFilled";
// import Paper from '@material-ui/core/Paper';
import AddIcon from "@material-ui/icons/Add";
// import EventIntro from 'components/Event/EventIntro';
// import BlockTitle  from 'components/UI/BlockTitle';
// import BlockButton  from 'components/UI/BlockButton';
// import MyEventsContainer from 'components/Event/MyEventsContainer';
import RemainingTime from "components/UI/RemainingTime";
// import Spinner from 'components/UI/Spinner';
// import Header from '../Header/Header';
// import Footer from '../Footer';
// import LiveHelp from './LiveHelp';
// import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
// import Bubble from 'components/UI/Bubble';
// import HelpSpeedTest from 'components/Help/HelpSpeedTest';
import PopinWrapper from "components/PopinWrapper";
import EventSubscription from "components/Event/EventSubscription";
import EventSubscriptionFor from "components/Event/EventSubscriptionFor";
import DialogPopinButton from "components/UI/Dialog/DialogPopinButton";
// import { Redirect } from 'react-router-dom'
// import { withRouter } from 'react-router-dom'
import { primaryColor } from "helpers/colors";
import getCardImage from "helpers/getCardImage";
import gotoLiveRoom from "helpers/gotoLiveRoom";
const styles = (theme) => {
  // console.log(theme)
  return {
    cardRoot: {
      padding: "40px 20px",
      // marginBottom: '30px',
      margin: "0 auto 30px",
      maxWidth: 1280,
      // background: 'linear-gradient(278.43deg, #FFCCE7 0%, #30003B 80%)',
      borderBottom: "1px #fff solid",
    },
    h2: {
      // fontSize: '120%',
      fontSize: "32px",
      fontWeight: "bold",
    },
    embed: {
      maxWidth: "initial",
      padding: "30px 40px 20px",
      margin: "0 auto",
      borderBottom: "1px #fff solid",
    },
    cardImage: {
      position: "absolute",
      backgroundSize: "contain",
      top: 30,
      right: 30,
      borderRadius: 90,
      width: 130,
      height: 130,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "50% 50%",
      border: "1px #ccc solid",
      [theme.breakpoints.down("sm")]: {
        position: "relative",
        top: "initial",
        right: "initial",
        margin: "0 auto 40px",
      },
    },
    cartTitle: {
      fontSize: "33px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "24px",
        marginBottom: "20px",
      },
    },
    cardtDescripion: {
      fontSize: "15px",
      [theme.breakpoints.down("sm")]: {
        // fontSize: '15px',
        marginBottom: "20px",
      },
    },
    cardContent: {
      width: "80%",
      margin: "40px 0",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    cardContentEmbed: {
      margin: "40px 0 0",
    },
    cardTimeRemaininTitle: {
      // color: primaryColor,
      fontSize: "30px",
      marginBottom: 20,
    },
    cardTimeRemaininText: {
      fontWeight: "bold",
      // color: primaryColor,
      fontSize: "32px",
    },
    // cardButton: {
    //   fontSize: "11px",
    //   padding: "15px 40px",
    //   backgroundColor: "#fff",
    //   margin: "0 auto 20px",
    //   display: "flex",
    //   color: primaryColor,
    //   fontWeight: "bold",
    //   letterSpacing: "0.92px",
    //   backgroundImage: "none",
    //   "&:hover": {
    //     color: "#fff",
    //     backgroundColor: primaryColor,
    //     backgroundImage: "none",
    //   },
    // },
    cardTimeRemainin: {
      textAlign: "center",
      [theme.breakpoints.down("sm")]: {},
    },
    remainintTime: {
      fontSize: "30px",
      marginBottom: 20,
      [theme.breakpoints.down("sm")]: {
        fontSize: "18px",
        marginBottom: 10,
      },
    },
  };
};
class EventCardSimple extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeRemaining: undefined,
    };
    this._runRemainingTimer = this._runRemainingTimer.bind(this);
    this._gotoLiveRoom = this._gotoLiveRoom.bind(this);
  }
  componentDidMount() {
    if (this.props.showRemainingTime === true) this._startTimer();
  }
  componentDidUpdate(oldProps, oldState) {
    if (
      this.props.showRemainingTime === true &&
      oldProps.$$data === undefined &&
      this.props.data !== undefined
    ) {
      this._startTimer();
    }
    if (
      oldState.showLiveButton !== true &&
      this.state.showLiveButton === true
    ) {
      const { $$card, $$subscriptions } = this.props;
      if (
        this.props.$$subscriptions.contains(this.props.$$card.get("id")) &&
        this.props.onLiveStarted
      )
        this.props.onLiveStarted();
    }
  }
  componentWillUnmount() {
    this._stopTimer();
  }
  _stopTimer() {
    if (this._remainingTimer) clearInterval(this._remainingTimer);
  }
  _startTimer() {
    const { $$card } = this.props;
    if ($$card === undefined) return;
    this._cardTimer = $$card.get("eventDate");
    this._remainingTimer = setInterval(this._runRemainingTimer, 1000);
    this._runRemainingTimer();
  }
  _runRemainingTimer() {
    const { $$card } = this.props;
    if ($$card === undefined) return;
    const timeRemaining =
      $$card !== undefined ? getRemainingTime($$card.get("eventDate")) : {};
    if (
      (timeRemaining.days <= 0 &&
        timeRemaining.hours <= 0 &&
        timeRemaining.minutes <= 15) ||
      $$card.get("eventState") === "live"
    ) {
      this.setState(
        {
          showLiveButton: true,
        },
        () => {
          // console.log('STOPPPING')
          this._stopTimer();
        }
      );
    } else {
      const { showLiveButton } = this.state;
      // console.log('RUN')
      this.setState({
        timeRemaining,
      });
    }
  }
  _gotoLiveRoom(e) {
    e.preventDefault();
    const { $$card, history } = this.props;
    gotoLiveRoom($$card, (res) => {
      if (res === true) history.push("/live/" + $$card.get("id"));
    });
  }
  _getCard() {
    const { $$data } = this.props;
    return $$data !== undefined &&
      $$data.get("live") !== undefined &&
      $$data.get("live").size > 0
      ? $$data.get("live").get(0)
      : undefined;
  }
  render() {
    const {
      userRole,
      classes,
      $$card,
      style,
      $$subscriptions,
      onSubscriptionComplete,
      showRemainingTime,
      embed,
      $$user,
      showDescription,
      remainingTimeOnly,
    } = this.props;
    const cardImage = getCardImage($$card);
    const { timeRemaining, showLiveButton } = this.state;
    return (
      <React.Fragment>
        <Box
          py={2}
          px={2}
          className={clsx(classes.cardRoot, {
            [classes.embed]: embed,
          })}
          style={style}
        >
          <If
            condition={
              showRemainingTime !== false &&
              timeRemaining !== undefined &&
              showLiveButton !== true &&
              timeRemaining.days >= 0 &&
              timeRemaining.hours >= 0 &&
              timeRemaining.minutes >= 0
            }
          >
            <Grid item={true} xs={12}>
              <div className={classes.cardTimeRemainin}>
                <Typography variant="h5" gutterBottom={true}>
                  Votre prochaine conférence débute dans :
                </Typography>
                <RemainingTime
                  days={timeRemaining.days}
                  hours={timeRemaining.hours}
                  minutes={timeRemaining.minutes}
                  className={classes.remainintTime}
                  variant={"h4"}
                />
                <If condition={showLiveButton !== true}>
                  <Typography variant="h6" style={{ color: "#fff" }}>
                    <span className={classes.inline}>
                      Vous verrez apparaître ici un bouton "accéder au
                      live"&nbsp;
                    </span>
                    <span className={classes.inline}>
                      15 minutes avant le début de votre emission
                    </span>
                  </Typography>
                </If>
              </div>
            </Grid>
          </If>
          <If
            condition={showRemainingTime !== false && showLiveButton === true}
          >
            <Box mb={3} maxWidth="80%" ml={"10%"}>
              <Typography variant="h5" align="center" gutterBottom={true}>
                Actuellement live :
              </Typography>
              <Typography variant="h5" align="center" gutterBottom={true}>
                {$$card.get("eventTitle")}
              </Typography>
            </Box>
          </If>
          <If condition={remainingTimeOnly !== true}>
            <Choose>
              <When
                condition={
                  userRole !== undefined &&
                  userRole !== "visitor" &&
                  $$card.get("eventState") !== "replay" &&
                  (userRole !== "member" ||
                    (userRole === "member" &&
                      $$subscriptions.contains($$card.get("id")))) &&
                  showLiveButton === true
                }
              >
                <Box align="center" width="100%">
                  <Button
                    size="large"
                    className={classes.cardButton}
                    onClick={this._gotoLiveRoom}
                  >
                    <span>Accéder au live</span>
                  </Button>
                </Box>
              </When>
              <Otherwise>
                <If
                  condition={
                    userRole !== "staff" && $$card.get("eventState") === "live"
                  }
                >
                  <Typography variant="h5" align="center" gutterBottom={true}>
                    Veuillez vous inscrire ci-dessous pour participer à cette
                    webconférence !
                  </Typography>
                </If>
              </Otherwise>
            </Choose>
            <If condition={userRole === undefined || userRole === "visitor"}>
              <DialogPopinButton
                trigger={PopinWrapper}
                triggerProps={{
                  className: classes.cardButton,
                  label: "S'inscrire",
                  endIcon: <AddIcon />,
                  size: "large",
                  icon: false,
                  button: true,
                }}
                popinTitle={false}
                popinTitleStyle={{
                  paddingBottom: 0,
                  height: 1,
                }}
                popinContent={RegistrationTwoStepsForm}
                popinContentProps={{
                  onFormComplete: onSubscriptionComplete,
                  onRegistrationShow: onSubscriptionComplete,
                  $$event: $$card,
                  $$user: $$user,
                  showRecap: true,
                  closeOnComplete: true,
                  // $$events: $$events,
                  userRole,
                }}
                openOnMount={false}
                onClosed={onSubscriptionComplete}
              />
            </If>
          </If>
        </Box>
      </React.Fragment>
    );
  }
}
export default withRouter(withStyles(styles)(EventCardSimple));



// WEBPACK FOOTER //
// ./src/components/Event/EventCardBanner.jsx